// Only known service codes become user-facing text. Never echo URLs or
// arbitrary server diagnostics, including WebSocket close reasons.
export const getRealtimeErrorKey = (reason: unknown, code?: number): string => {
  switch (reason) {
    case 'invalid_s2t_token':
    case 'unauthenticated':
      return 'realtime-sign-in-again';
    case 'invalid_language':
    case 'language_not_allowed':
      return 'realtime-choose-language';
    case 'stream_limit_reached':
      return 'realtime-stream-limit';
    case 'no_subscription_found':
    case 'no_subscriptions_found':
    case 'license_missing_entitlement':
    case 'no_realtime_token_for_organization':
      return 'realtime-subscription-required';
    case 'stream_unavailable':
      return 'realtime-check-stream';
    case 'connection_idle_timeout':
    case 'idle_timeout':
      return 'realtime-session-ended';
    default:
      switch (code) {
        case 4403:
          return 'realtime-sign-in-again';
        case 4400:
        case 4454:
          return 'realtime-choose-language';
        case 4455:
          return 'realtime-stream-limit';
        case 4402:
        case 4451:
          return 'realtime-subscription-required';
        case 4408:
          return 'realtime-session-ended';
        default:
          return 'realtime-connection-unavailable';
      }
  }
};
